import React, { ReactElement, useEffect, useState } from 'react';
import { HeadTag } from 'shared/components';
import {
  Box,
  CircularProgress,
  Grid,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material';

import { ReactComponent as Executive } from 'assets/images/ic_executive_training.svg';
import { ReactComponent as Function } from 'assets/images/ic_function_training.svg';
import { ReactComponent as Model } from 'assets/images/ic_model_training.svg';
import { ReactComponent as Back } from 'assets/images/ic_back.svg';
import { ReactComponent as Operation } from 'assets/images/ic_operation_training.svg';
import { ReactComponent as Owner } from 'assets/images/ic_owners_training.svg';
import { ReactComponent as General } from 'assets/images/ic_general_training.svg';
import { useNavigate } from 'react-router-dom';
import { TrainingPorgramsService } from 'services/TrainingProgramService';
import { Utils } from 'shared/helpers';
import PageHeader from 'shared/components/PageHeader';
import { AppPrimaryButton } from 'shared/components/AppComponents';

const AddNewTemplate = (): ReactElement => {
  const navigation = useNavigate();
  const [programData, setProgramData] = useState<any>([]);
  const [loadinProgram, setLoadingProgram] = useState(true);

  const PROGRAM_ICON = [
    { title: 'executive', component: Executive },
    {
      title: 'Risk, Compliance, Legal & Audit Functions Training',
      component: Function,
    },
    { title: 'AI', component: Model },
    { title: 'IT', component: Operation },
    { title: 'Owner', component: Owner },
    { title: 'General', Component: General },
  ];

  useEffect(() => {
    TrainingPorgramsService.getTrainingDetails()
      .then((response) => {
        const { data } = response.data;
        setProgramData(data?.records);

        setLoadingProgram(false);
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
      });
  }, []);

  return (
    <Box>
      <PageHeader
        title="Add New Training Program"
        description="First, select from the options how you'd like to create your training."
        actions={
          <AppPrimaryButton
            className="btn-small"
            onClick={() => navigation('/training-programs/training')}
            startIcon={
              <SvgIcon
                component={Back}
                inheritViewBox
                className="view-icon"
                fontSize="inherit"
              />
            }
            title="Return Training Management"
          />
        }
      />

      <Box className="training training-programs">
        <HeadTag title="Select a Template" />

        <Box className="training-programs add-template">
          <Stack spacing={2} direction="column">
            <Box className="training-template-heading">
              <Typography variant="h4">Select a Template</Typography>
              <Typography component="span" variant="body1">
                Choose a ready-to-use training template designed for specific
                roles.
              </Typography>
            </Box>

            {loadinProgram && (
              <Box sx={{ alignSelf: 'center', textAlign: 'center' }}>
                <CircularProgress />
              </Box>
            )}
            <Box>
              <Grid container spacing={5}>
                {!loadinProgram &&
                  programData.length > 0 &&
                  programData.map((details: any, index: number) => (
                    <Grid
                      item
                      md={4}
                      xs={12}
                      key={index}
                      sx={{
                        display: 'flex',
                      }}
                    >
                      <Box
                        className="selection-template"
                        component="button"
                        sx={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                        onClick={() => {
                          navigation(
                            `/training-programs/add-ready-to-use-template/${details?._id}`
                          );
                        }}
                      >
                        <Stack direction="column" spacing={1}>
                          <SvgIcon
                            component={
                              PROGRAM_ICON.find(
                                (item) => item.title === details?.title
                              )?.component || General
                            }
                            inheritViewBox
                            className="view-icon"
                            fontSize="inherit"
                            htmlColor="#3D3C42"
                          />
                          <Typography variant="h6">{details?.title}</Typography>
                        </Stack>
                        <Typography variant="body2" component="span">
                          {details?.description}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default AddNewTemplate;
